import { render, staticRenderFns } from "./changeLocation.vue?vue&type=template&id=718dcb7e&scoped=true&"
import script from "./changeLocation.vue?vue&type=script&lang=js&"
export * from "./changeLocation.vue?vue&type=script&lang=js&"
import style0 from "./changeLocation.vue?vue&type=style&index=0&id=718dcb7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718dcb7e",
  null
  
)

export default component.exports